import { render, staticRenderFns } from "./PasswordAndOTPDialog.vue?vue&type=template&id=7d6fd243&"
import script from "./PasswordAndOTPDialog.vue?vue&type=script&lang=js&"
export * from "./PasswordAndOTPDialog.vue?vue&type=script&lang=js&"
import style0 from "./PasswordAndOTPDialog.vue?vue&type=style&index=0&id=7d6fd243&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDialog,VForm,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d6fd243')) {
      api.createRecord('7d6fd243', component.options)
    } else {
      api.reload('7d6fd243', component.options)
    }
    module.hot.accept("./PasswordAndOTPDialog.vue?vue&type=template&id=7d6fd243&", function () {
      api.rerender('7d6fd243', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/widgets/PasswordAndOTPDialog.vue"
export default component.exports